import React from 'react'
import { posDisplaySize } from '../settings'

export function PosPage(props) {
  const styles = {
    wrapOuter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
      backgroundColor: '#fff',
      // zIndex: "1"
    },
    wrapInner: {
      width: posDisplaySize.width,
      height: posDisplaySize.width * posDisplaySize.ratio,
      position: 'relative',
      // zIndex: "1",
    },
  }
  return (
    <div style={styles.wrapOuter}>
      <div style={styles.wrapInner}>{props.children}</div>
    </div>
  )
}

export function PosSectionMain(props) {
  const styles = {
    wrapOuter: {
      marginTop: 10,
      // border: '1px solid #ddd',
      ...props.style,
    },
  }
  return <div style={styles.wrapOuter}>{props.children}</div>
}

export function FooterBar(props) {
  const styles = {
    wrapOuter: {
      height: posDisplaySize.footerHeight,
      backgroundColor: props.colors.dark,
      ...props.style,
    },
  }
  return <div style={styles.wrapOuter}>{props.children}</div>
}
